import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { LoadingScreen } from "@/components/common";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen label="Verifying access…" />;
  if (!user) return <Navigate to="/login" replace />;
  const roles = Array.isArray(role) ? role : role ? [role] : [];
  if (roles.length && !roles.some((r) => user.roles?.includes(r))) {
    const fallback = user.roles?.includes("admin") ? "/admin"
      : user.roles?.includes("lead_manager") ? "/admin/lead-management"
        : user.roles?.includes("agency") ? "/agency" : "/dashboard";
    return <Navigate to={fallback} replace />;
  }
  return children;
}
